import { render, staticRenderFns } from "./OwnerOccupancyCreditDetail.vue?vue&type=template&id=f2e03778&scoped=true&lang=pug"
import script from "./OwnerOccupancyCreditDetail.vue?vue&type=script&lang=ts"
export * from "./OwnerOccupancyCreditDetail.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f2e03778",
  null
  ,true
)

export default component.exports